define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * OGC标准协议。
     *
     * @exports EnumOGCType
     * 
     * @see OGCConnector#serviceType
    */
    var EnumOGCType = {
        /**
         * WMS协议。
         * @type {String}
         * @constant
         */
        WMS: "WMS",

        /**
         * WMTS协议。
         * @type {String}
         * @constant
         */
        WMTS: "WMTS",

        /**
         * WFS协议。
         * @type {String}
         * @constant
         */
        WFS: "WFS"
    }
    freezeObject(EnumOGCType)

    /**
     * 反向查找OGC标准协议的名称。
     * 
     * @param {Number} value OGC标准协议的数值。
     * @returns {String} OGC标准协议的名称。
     */
    function getName(value) {
        for (var key in EnumOGCType) {
            if (EnumOGCType.hasOwnProperty(key) && EnumOGCType[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        WMS: "WMS",
        WMTS: "WMTS",
        WFS: "WFS",
        getName: getName
    }
})